export default {
  getStockItemActivity: (state) => state.stockItemActivity,
};
